function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var brands = new (/*#__PURE__*/function () {
  function Brands() {
    _classCallCheck(this, Brands);
    this.init();
  }
  return _createClass(Brands, [{
    key: "init",
    value: function init() {
      this.btns = document.querySelectorAll('.brands-nav__btn');
      this.subNavigations = document.querySelectorAll('.brands-nav__sub-wrapper');
      this.items = document.querySelectorAll('.brands__items > li');
      this.itemsWrapper = document.querySelector('.brands__items');
      document.addEventDelegate('click', this.onBtnBrandClick.bind(this), '.brands-nav__btn');
      document.addEventDelegate('click', this.onArrowBrandClick.bind(this), '.brands__items-arrow');
    }
  }, {
    key: "onArrowBrandClick",
    value: function onArrowBrandClick(e) {
      e.preventDefault();
      var w = this.items[0].clientWidth + 20;
      this.itemsWrapper.scroll(this.itemsWrapper.scrollLeft + w, 0);
    }
  }, {
    key: "onBtnBrandClick",
    value: function onBtnBrandClick(e) {
      var cat = e.target.getAttribute('data-cat');
      var subcat = e.target.getAttribute('data-subcat');
      this.showSubCatNavigation(cat);
      this.filterItemsByCat(cat, subcat);
      this.changeCurrentBtn(cat, subcat);
    }
  }, {
    key: "showSubCatNavigation",
    value: function showSubCatNavigation(cat) {
      this.subNavigations.forEach(function (subcat) {
        var doShow = subcat.getAttribute('data-cat') === cat;
        subcat.style.display = doShow ? '' : 'none';
      });
    }
  }, {
    key: "filterItemsByCat",
    value: function filterItemsByCat(cat, subcat) {
      this.items.forEach(function (item) {
        var cats = item.getAttribute('data-cats');
        var doShow = true;
        if (cat) {
          doShow = cats.indexOf(cat) !== -1;
        }
        if (subcat) {
          doShow = doShow && cats.indexOf(subcat) !== -1;
        }
        item.style.display = doShow ? '' : 'none';
      });
    }
  }, {
    key: "changeCurrentBtn",
    value: function changeCurrentBtn(cat, subcat) {
      this.btns.forEach(function (item) {
        var isCurrent = item.getAttribute('data-cat') === cat;
        var dataSubCat = item.getAttribute('data-subcat');
        if (dataSubCat && !subcat) {
          isCurrent = false;
        } else if (dataSubCat && subcat) {
          isCurrent = isCurrent && dataSubCat === subcat;
        }
        if (isCurrent) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
  }]);
}())();